<template>
    <div id="residualManage">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select clearable v-model="searchForm.brandId" clearable filterable placeholder="品牌" @change="selectBrand" >
                    <el-option 
                        v-for="(item,index) in brandList" 
                        :key="index"  
                        :label="item.brandName" 
                        :value="item.brandId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
            <el-select clearable v-model="searchForm.categoryId" clearable filterable style="width: 100%;"  placeholder="品类" @change="selectCategory">
                    <el-option 
                        v-for="(item,index) in categoryList"  
                        :key="index" 
                        :label="item.categoryName" 
                        :value="item.categoryId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select clearable v-model="searchForm.modelId" clearable filterable style="width: 100%;"  placeholder="型号">
                    <el-option 
                        v-for="(item,index) in modelList" 
                        :key="index" :label="item.modelName" 
                        :value="item.modelId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.materialCode" clearable placeholder="物料编号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select filterable clearable v-model="searchForm.createUser" placeholder="操作人">
                    <el-option v-for="(item,index) in operatorUserAllList" 
                        :label="item.staffName" 
                        :value="item.staffName" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
           <!--  <el-form-item style="width:350px;margin-bottom:15px">
               <el-date-picker
                   v-model="valueTime3"
                   value-format="yyyy-MM-dd"
                   type="daterange"
                   format="yyyy-MM-dd"
                   range-separator="-"
                   :default-time="['00:00:00', '11:59:59']"
                   start-placeholder="开始日期"
                   end-placeholder="结束日期">
               </el-date-picker>
           </el-form-item> -->
            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
               <!--  <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button> -->
               <el-button v-if="basicsAuth.add" size="medium" type="success" @click="createWaste()">新建</el-button>
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 10px;" @click="refresh()"></i>
            </el-form-item>
            <!-- <el-form-item class="fr">
                <el-col style="text-align:right">
                    <el-button v-if="basicsAuth.add" size="medium" type="success" @click="createWaste()">新建</el-button>
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                </el-col>
            </el-form-item> -->
        </el-form>
        <el-col>
            <el-card class="box-card" style="width: 100%;">
                <el-table
                    :data="returnData"
                    border
                    id="tableId"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        prop="brandName"
                        width="100"
                        label="品牌">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="categoryName"
                        width="100"
                        label="品类">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="modelName"
                        width="140"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialCode"
                        width="110"
                        label="物料编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialName"
                        width="230"
                        label="物料名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createUser"
                        label="操作人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="155"
                        prop="createTime"
                        label="提交时间">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="initiateMode"
                        
                        label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.initiateMode == 1">启用</span>
                            <span v-else>禁用</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        
                        label="操作">
                        <template slot-scope="scope">
                            <span class="edit-color" @click="updateWaste(scope.row.materialCode)" style="margin-right: 10px;display: inline-block">编辑</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :title="textModelMenu[dialogModelStatus]" :visible.sync="dialogFormVisible" width="800px" @close="emptyDialog('modelForm')">
                    <el-form ref="modelForm" :model="modelForm" :label-position="formLabelWidth" label-width="60px" :rules="modelFormRules">
                        <div class="item-flex-content" v-if="dialogModelStatus == 'create'">
                            <div class="form-item-flex">
                                <el-form-item style="margin-bottom: 15px;" label="品牌" prop="brandId">
                                    <el-select clearable v-model="modelForm.brandId" style="width: 90%;" placeholder="品牌" @change="selectFormBrand">
                                        <el-option v-for="(item,index) in brandFormList" :key="index"  :label="item.brandName" :value="item.brandId">{{item.brandName}}</el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 15px;" label="品类" prop="categoryId">
                                    <el-select clearable v-model="modelForm.categoryId" style="width: 90%;"  placeholder="品类" @change="selectFormCategory">
                                        <el-option v-for="(item,index) in categoryFormList"  :selected="{'selected':index==0}" :key="index" :label="item.categoryName" :value="item.categoryId">{{item.categoryName}}</el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 15px;" label="型号" prop="modelId">
                                    <el-select clearable filterable v-model="modelForm.modelId" style="width: 90%;"  placeholder="型号" @change="selectFormModel">
                                        <el-option v-for="(item,index) in modelFormList" :key="index" :label="item.modelName" :value="item.modelId">{{item.modelName}}</el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="form-item-flex">
                                <el-form-item style="margin-bottom: 15px;width: 39%" label="颜色">
                                    <el-select clearable filterable v-model="modelForm.colorId" style="width: 90%;" placeholder="颜色">
                                        <el-option v-for="(item,index) in colorFormList" :key="index"  :label="item.colorName" :value="item.colorId">{{item.colorName}}</el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 15px;width: 77%" label="物料" prop="materialCoding">
                                    <el-select clearable filterable v-model="modelForm.materialCoding" style="width: 96%;" placeholder="物料" @change="selectFormMaterial">
                                        <el-option v-for="(item,index) in materialFormList" :key="index"  :label="item.materialName" :value="item.materialCoding">{{item.materialName}}</el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <el-form-item label="物料编码" label-width="80px" style="width: 97.5%">
                                <el-input v-model.trim="modelForm.materialCode" placeholder="物料编码" disabled auto-complete="off"></el-input>
                            </el-form-item>
                        </div>
                        <div class="item-flex-content" v-if="dialogModelStatus == 'update'">
                            <div class="form-item-flex">
                                <el-form-item style="margin-bottom: 15px;" label="品牌" prop="brandId">
                                    <el-select clearable v-model="modelForm.brandName" style="width: 90%;" placeholder="品牌" @change="selectFormBrand" disabled>
                                        <el-option v-for="(item,index) in brandFormList" :key="index"  :label="item.brandName" :value="item.brandName">{{item.brandName}}</el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 15px;" label="品类" prop="categoryId">
                                    <el-select clearable v-model="modelForm.categoryName" style="width: 90%;"  placeholder="品类" disabled>
                                        <el-option v-for="(item,index) in categoryFormList"  :selected="{'selected':index==0}" :key="index" :label="item.categoryName" :value="item.categoryName">{{item.categoryName}}</el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 15px;" label="型号" prop="modelId">
                                    <el-select clearable filterable v-model="modelForm.modelName" style="width: 90%;"  placeholder="型号" disabled>
                                        <el-option v-for="(item,index) in modelFormList" :key="index" :label="item.modelName" :value="item.modelName">{{item.modelName}}</el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="form-item-flex">
                                <el-form-item style="margin-bottom: 15px;width: 39%" label="颜色">
                                    <el-select clearable filterable v-model="modelForm.colorName" style="width: 90%;" placeholder="颜色" disabled>
                                        <el-option v-for="(item,index) in colorFormList" :key="index"  :label="item.colorName" :value="item.colorName">{{item.colorName}}</el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 15px;width: 77%" label="物料" prop="materialCoding">
                                    <el-select clearable filterable v-model="modelForm.materialName" style="width: 96%;" placeholder="物料" disabled>
                                        <el-option v-for="(item,index) in materialFormList" :key="index"  :label="item.materialName" :value="item.materialName">{{item.materialName}}</el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <el-form-item label="物料编码" label-width="80px" style="width: 97.5%">
                                <el-input v-model.trim="modelForm.materialCode" placeholder="物料编码" disabled auto-complete="off"></el-input>
                            </el-form-item>
                        </div>
                        <div class="form-item-flex">
                            <el-form-item label="残值类型" label-width="80px">
                                <el-select clearable :disabled="dialogModelStatus=='update'" v-model="modelForm.residualType" style="width: 90%;"  placeholder="请选择残值类型" @change="selectResidualType">
                                    <el-option v-for="(item,index) in residualTypeList" :key="index" :label="item.paraName" :value="item.paraValue">{{item.paraName}}</el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="残值价格" label-width="80px">
                                <el-input :disabled="dialogModelStatus=='update'" v-model.trim="modelForm.residualValue" type="number" placeholder="请输入残值价格" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label-width="20px">
                                <el-button type="primary" :disabled="dialogModelStatus=='update'" @click="addResidual" size="small">添加</el-button>
                            </el-form-item>
                        </div>
                        <el-table
                            :data="residualList"
                            height="250"
                            border
                            :header-cell-style="{'text-align':'center'}"
                            style="width: 100%">
                            <el-table-column
                                prop="residualTypeName"
                                label="残值类型"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="residualValue"
                                label="残值价格(元)"
                                align="center">
                                <template slot-scope="scope">
                                    <el-input v-if="dialogModelStatus == 'update'" type="number" v-model.trim="scope.row.residualValue"></el-input>
                                    <span v-else>{{scope.row.residualValue}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                v-if="dialogModelStatus == 'update'"
                                label="是否启用">
                                <template slot-scope="scope">
                                    <el-tooltip :content="scope.row.statusText" placement="top">
                                        <el-switch v-model="scope.row.state" @change="deleteUpdateResidual(scope.row)"></el-switch>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                v-if="dialogModelStatus == 'create'"
                                label="操作">
                                <template slot-scope="scope">
                                    <span style="display: block;font-size:14px;color:#F56C6C" @click="deleteCreateResidual(scope.$index)">移除</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="emptyDialog('modelForm')">取 消</el-button>
                        <el-button type="primary" v-if="dialogModelStatus == 'update'" @click="saveModelFormSubmitBtn('modelForm')">保 存</el-button>
                        <el-button type="primary" v-else @click="createModelFormSubmitBtn('modelForm')">新 建</el-button>
                    </div>
                </el-dialog>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import {wasteList,selectAllBrand,selectCategory,selectModel,queryColor,selectMaterialByColor,selectParameterInfoBusiness,addMaterialResidual,updateMaterialResidual,queryUser,selectMaterialManagements} from "../../../api/api";
    import {getPermission} from '../../../api/authRequest'
    export default {
        name: 'residualManage',
        components: {},
        data () {
            return {
                valueTime3:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                dialogFormVisible:false,
                labelPosition:'left',
                formLabelWidth:'left',
                searchForm:{
                    brandId:'',        //品牌ID
                    categoryId:'',     //品类ID
                    modelId:'',        //型号ID
                    initiateMode:'',   //是否启用
                    materialCode:'',   //物料编号
                    createUser: '',    //创建人
                    createTimeFrom:'', // 创建时间（起）
                    createTimeTo:''    //创建时间（止）
                },
                modelForm:{
                    brandId:'',        //品牌ID
                    categoryId:'',     //品类ID
                    modelId:'',        //型号ID
                    colorId:'',        //颜色ID
                    materialCoding:'', //物料编码
                    materialCode:'',
                    residualType:'',    //残值类型
                    residualTypeName:'',//残值名称
                    residualValue:'',   //残值价格
                    initiateMode:1      //启用状态
                },
                dialogModelStatus: "",
                textModelMenu: {
                    update: "编辑残值定价",
                    create: "新建残值定价"
                },
                modelFormRules:{//validateRoleName
                    brandId: [{ required: true, message: "请选择品牌", trigger: "blur" }],
                    categoryId: [{ required: true, message: "请选择品类", trigger: 'blur' }],
                    modelId: [{ required: true, message: "请选择型号", trigger: 'blur' }],
                    colorId: [{ required: true, message: "请选择颜色", trigger: 'blur' }],
                    materialCoding: [{ required: true, message: "请选择物料", trigger: 'blur' }],
                },
                brandList:[],       //品牌数组
                categoryList:[],    //品类数组
                modelList:[],       //型号数组
                brandFormList:[],       //modelForm品牌数组
                categoryFormList:[],    //modelForm品类数组
                modelFormList:[],       //modelForm型号数组
                colorFormList:[],       //modelForm颜色数组
                materialFormList:[],    //modelForm物料数组
                residualTypeList:[],    //modelForm残值数组
                residualList:[],        //modelForm残值添加列表数组
                returnData: [],
                operatorUserAllList:[],
                basicsAuth:{
                    add:false
                }
            }
        },
        mounted () {
		    this.basicsAuth.add = getPermission('/api/scrap_value_manager/add');
        },
        created:function(){
            this.getBrandList(); //请求机型品牌数据
            this.getWasteList(); //请求废料残值定价列表数据
            this.getResidualTypeList();
            this.getOperatorUserAllList();
        },
        methods: {
            clearFrom(){
                this.searchForm = {
                    brandId:'',        //品牌ID
                    categoryId:'',     //品类ID
                    modelId:'',        //型号ID
                    initiateMode:'',   //是否启用
                    materialCode:'',   //物料编号
                    createUser: '',    //创建人
                    createTimeFrom:'', // 创建时间（起）
                    createTimeTo:''    //创建时间（止）
                };
                this.valueTime3 = [];
            },
            getOperatorUserAllList(){
                queryUser({type:2}).then(res => {     
                    if (res.data.status==100) {
                        this.operatorUserAllList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //searchForm选择品牌
            selectBrand(){
                this.getCategoryList(0);
            },
            //searchForm选择品类
            selectCategory(){
                this.getModelList(0);
            },
            //modelForm选择品牌
            selectFormBrand(){
                this.getCategoryList(1);
            },
            //modelForm选择品类
            selectFormCategory(){
                this.getModelList(1);
            },
            //modelForm选择型号
            selectFormModel(){
                this.getColorList();
                this.getMateriaList();
            },
            //modelForm选择物料
            selectFormMaterial(e){
                this.materialFormList.forEach((item,index)=>{
                    if(item.materialCoding == e){
                        this.modelForm.materialCode = item.materialCode
                    }
                })
            },
            //modelForm选择残值类型
            selectResidualType(e){
                this.residualTypeList.forEach((item,index)=>{
                    if(item.paraValue == e){
                        this.modelForm.residualTypeName = item.paraName;
                    }
                })
            },
            //新建删除残值数据
            deleteCreateResidual(index){
                this.residualList.splice(index,1);
            },
            //启用&禁用
            deleteUpdateResidual(row){
                row.statusText = row.state ? '已启用' : '已禁用';
            },
            //添加残值数据
            addResidual(){
                if(!this.modelForm.residualTypeName){
                    this.$message({
                        message: '请选择残值类型',
                        type: "warning"
                    });
                    return;
                }
                if(!this.modelForm.residualValue){
                    this.$message({
                        message: '请输入残值价格',
                        type: "warning"
                    });
                    return;
                }
                let isHave = false;
                if(this.residualList.length > 0){
                    this.residualList.forEach((item,index)=>{
                        if(item.modelId == this.modelForm.modelId){
                            if(item.residualType == this.modelForm.residualType){
                                isHave = true
                            }
                        }
                    })
                    if(!isHave){
                        this.residualList.push({
                            brandId:this.modelForm.brandId,
                            categoryId:this.modelForm.categoryId,
                            modelId:this.modelForm.modelId,
                            colorId:this.modelForm.colorId,
                            materialCoding:this.modelForm.materialCoding,
                            residualTypeName:this.modelForm.residualTypeName,
                            residualType:this.modelForm.residualType,
                            residualValue:this.modelForm.residualValue,
                            initiateMode:1
                        })
                    }else{
                        this.$message({
                            message: '该残值已添加至列表，请重新添加',
                            type: "warning"
                        });
                    }
                }else{
                    this.residualList.push({
                        brandId:this.modelForm.brandId,
                        categoryId:this.modelForm.categoryId,
                        modelId:this.modelForm.modelId,
                        colorId:this.modelForm.colorId,
                        materialCoding:this.modelForm.materialCoding,
                        residualTypeName:this.modelForm.residualTypeName,
                        residualType:this.modelForm.residualType,
                        residualValue:this.modelForm.residualValue,
                        initiateMode:1
                    })
                }
                
            },
            //确定新建残值定价
            createModelFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(this.residualList.length == 0){
                            this.$message({
                                message: '至少需要添加一条残值数据才能提交',
                                type: "warning"
                            });
                            return;
                        }
                        addMaterialResidual({details:this.residualList}).then(res => {
                            if (res.data.status == '100') {
                                this.$message({
                                    message: "恭喜你，新建成功",
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.emptyDialog(formname);
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //确定编辑残值定价
            saveModelFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let details = [];
                        this.residualList.forEach((item,index)=>{
                            details.push({
                                id:item.id,
                                residualType:item.residualType,
                                residualValue:item.residualValue,
                                initiateMode:item.state ? 1 : 0
                            })
                        });
                        updateMaterialResidual({details:details}).then(res => {
                            if (res.data.status == 100) {
                                this.$message({
                                    message: "恭喜你，修改成功",
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.emptyDialog(formname);
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        });                       
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //清空弹窗
            emptyDialog(formname){
                this.residualList = [];
                this.dialogFormVisible = false;
                this.$refs[formname].resetFields();
                /*刷新*/
                this.refresh();
            },
            //残值类型
            getResidualTypeList(){
                let para = {
                    paraType:'residual_type'
                };
                selectParameterInfoBusiness(para).then(res => {
                    if (res.data.status==100) {
                        this.residualTypeList = res.data.results.list;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //机型品牌
            getBrandList(){
                selectAllBrand().then(res => {
                    if (res.data.status==100) {
                        this.brandList = res.data.results;
                        this.brandFormList = res.data.results;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //机型品类
            getCategoryList(type){
                let para = {};
                if(type == 0){
                    this.searchForm.categoryId = "";
                    this.searchForm.modelId = "";
                    this.categoryList = [];
                    this.modelList = [];   //清空型号数据
                    para={
                        brandId:this.searchForm.brandId
                    };
                }else{
                    this.modelForm.categoryId = "";
                    this.modelForm.modelId = "";
                    this.modelFormList = [];
                    this.modelForm.colorId = "";
                    this.colorFormList = [];
                    this.modelForm.materialCoding = "";
                    this.materialFormList = [];
                    this.modelForm.materialCode = "";
                    para={
                        brandId:this.modelForm.brandId
                    };
                }
                selectCategory(para).then(res => {
                    if (res.data.status==100) {
                        if(type == 0){
                            this.categoryList = res.data.results; 
                        }else{
                            this.categoryFormList = res.data.results; 
                        }        
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //机型型号
            getModelList(type){
                let para = {};
                if(type == 0){
                    this.searchForm.modelId = "";
                    para = {
                        brandId:this.searchForm.brandId,
                        categoryId:this.searchForm.categoryId
                    };
                }else{
                    this.modelForm.modelId = "";
                    this.modelForm.colorId = "";
                    this.colorFormList = [];
                    this.modelForm.materialCoding = "";
                    this.materialFormList = [];
                    this.modelForm.materialCode = "";
                    para = {
                        brandId:this.modelForm.brandId,
                        categoryId:this.modelForm.categoryId
                    };
                }
                selectModel(para).then(res => {
                    if (res.data.status==100) {
                        if(type == 0){
                            this.modelList = res.data.results;
                        }else{
                            this.modelFormList = res.data.results;
                        }
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //机型颜色
            getColorList(){
                this.modelForm.colorId = "";
                this.modelForm.materialCoding = "";
                this.materialFormList = [];
                this.modelForm.materialCode = "";
                let para = {
                    modelId:this.modelForm.modelId
                };
                queryColor(para).then(res => {
                    if (res.data.status==100) {
                        this.colorFormList = res.data.results;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //机型物料
            getMateriaList(){
                this.modelForm.materialCoding = "";
                this.modelForm.materialCode = "";
                let para = {
                    brandId:this.modelForm.brandId,
                    categoryId:this.modelForm.categoryId,
                    modelId:this.modelForm.modelId,
                    colorId:this.modelForm.colorId,
                    startRow:1,
                    pageSize:1000
                };
                selectMaterialManagements(para).then(res => {
                    if (res.data.status==100) {
                        this.materialFormList = res.data.results;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取残值管理列表
            getWasteList(){
                let para={
                    isListQuery:1,
                    materialCode: this.searchForm.materialCode,   //编号
                    createUser: this.searchForm.createUser,       //创建人
                    brandId:this.searchForm.brandId,              //品牌ID
                    categoryId:this.searchForm.categoryId,        //品类ID
                    modelId:this.searchForm.modelId,              //型号ID
                    createTimeFrom:this.searchForm.createTimeFrom,// 创建时间（起）
                    createTimeTo:this.searchForm.createTimeTo,    //创建时间（止）
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize
                }
                wasteList(para).then(res => {          
                    if (res.data.status=='100') {
                        res.data.results.list.forEach((item,index)=>{
                            item.createTime = this.filters.formatDate(item.createTime)
                        }) 
                        this.returnData = res.data.results.list;
                        this.pages.total = res.data.results.total;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getWasteList();
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getWasteList();
            },
            //新废料残值定价
            createWaste() {
                this.dialogFormVisible = true;
                this.dialogModelStatus = "create";
            },
            //编辑废料残值定价
            updateWaste(materialCode) {
                this.searchForm.materialCode = materialCode;
                wasteList({materialCode:materialCode}).then(res => {          
                    if (res.data.status=='100') { 
                        this.returnData = res.data.results.list;
                        this.pages.total = res.data.results.total;
                        this.residualList = res.data.results.list;
                        this.residualList.forEach((item,index)=>{
                            item.state = item.initiateMode == 1 ? true : false;
                            item.statusText = item.initiateMode == 1 ? '已启用' : '已禁用';
                        });
                        this.modelForm = this.returnData[0];
                        this.modelForm = {
                            brandId:this.returnData[0].brandId,               //品牌ID
                            brandName:this.returnData[0].brandName,           //品牌Name
                            categoryId:this.returnData[0].categoryId,         //品类ID
                            categoryName:this.returnData[0].categoryName,     //品类Name
                            modelId:this.returnData[0].modelId,               //型号ID
                            modelName:this.returnData[0].modelName,           //型号Name
                            colorId:this.returnData[0].colorId,               //颜色ID
                            colorName:this.returnData[0].colorName,           //颜色Name
                            materialCoding:this.returnData[0].materialCoding, //物料ID
                            materialName:this.returnData[0].materialName,     //物料Name
                            materialCode:this.returnData[0].materialCode,     //物料编码
                            residualType:'',    //残值类型
                            residualTypeName:'',//残值名称
                            residualValue:'',   //残值价格
                            initiateMode:1      //启用状态
                        };
                        this.dialogFormVisible = true;
                        this.dialogModelStatus = "update";
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //刷新
            refresh() {
                Object.keys(this.modelForm).forEach(key => this.modelForm[key] = '');
                Object.keys(this.searchForm).forEach(key => this.searchForm[key] = '');
                this.getWasteList();
            },
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(this.valueTime3 == null){
                            this.searchForm.createTimeFrom = ''
                            this.searchForm.createTimeTo = ''
                        }else if (this.valueTime3.length == 0) {
                            this.searchForm.createTimeFrom = ''
                            this.searchForm.createTimeTo = ''
                        }else{
                            this.searchForm.createTimeFrom = new Date(this.valueTime3[0] +" 00:00:00");
                            this.searchForm.createTimeTo = new Date(this.valueTime3[0] +" 23:59:59");
                        }
                        this.getWasteList()
                  
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    #residualManage{
        font-size: 14px;
        .headerT{
            margin:10px 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px; 
        }
        .form-item-flex{
            display:flex
        }
        .item-flex-content{
            padding-bottom:10px;
            border-bottom:1px solid #e3e3e3;
            margin-bottom:30px
        }
        .edit-color{
            color:#409EFF;
            cursor:pointer;
        }
    }
     .hewidth {
        width: 12% !important;
      }
</style>



// WEBPACK FOOTER //
// residualManage.vue?1455b3cc